/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, {useCallback} from 'react';

import {getClassName} from './BaseTab';

const Tab = ({id, label, active, setActive}) => {
    const onClick = useCallback(() => setActive(id), [id, setActive]);

    return (
        <li className={getClassName(id, active)} onClick={onClick} role="menuitem">
            {label}
        </li>
    );
};

export default Tab;
